<template>
  <transition name="dialog-fade">
    <div v-if="visible" class="custom-dialog-wrapper" @click.self="handleClose">
      <div class="custom-dialog-container" :style="{ width: containerWidth }">
        <!-- 弹窗头部 -->
        <div class="dialog-header">
          <span class="dialog-title">{{ title }}</span>
          <button class="dialog-close" @click="handleClose">
            <svg viewBox="0 0 24 24" width="18" height="18" stroke="currentColor" stroke-width="2" fill="none">
              <path d="M18 6L6 18M6 6l12 12" />
            </svg>
          </button>
        </div>
        <!-- 弹窗内容 -->
        <div class="dialog-body">
          <slider-captcha
            ref="sliderCaptcha"
            :width="sliderWidth"
            :height="sliderHeight"
            :api-url="apiUrl"
            :device-id="deviceId"
            @verified="onVerified"
          />
        </div>
        <!-- 可选底部提示 -->
        <div class="dialog-footer">
          <span class="footer-tip">拖动滑块完成验证</span>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import SliderCaptcha from './SliderCaptcha.vue'

export default {
  name: 'CustomCaptchaDialog',
  components: { SliderCaptcha },
  props: {
    title: { type: String, default: '安全验证' },
    width: { type: [Number, String], default: 440 },
    sliderWidth: { type: Number, default: 400 },
    sliderHeight: { type: Number, default: 200 },
    apiUrl: { type: String, default: '/api/Captcha' },
    deviceId: { type: String, default: '' }
  },
  data() {
    return {
      visible: false,
      resolvePromise: null,
      rejectPromise: null
    }
  },
  computed: {
    containerWidth() {
      if (typeof this.width === 'number') return this.width + 'px'
      return this.width
    }
  },
  methods: {
    open() {
      this.visible = true
      this.$nextTick(() => {
        if (this.$refs.sliderCaptcha) {
          this.$refs.sliderCaptcha.init()
        }
      })
      return new Promise((resolve, reject) => {
        this.resolvePromise = resolve
        this.rejectPromise = reject
      })
    },
    close() {
      this.visible = false
    },
    handleClose() {
      this.visible = false
      if (this.rejectPromise) {
        this.rejectPromise(new Error('用户取消验证'))
        this.resolvePromise = null
        this.rejectPromise = null
      }
      this.$emit('close')
    },
    onVerified(data) {
      this.visible = false
      if (this.resolvePromise) {
        this.resolvePromise(data.sessionToken)
        this.resolvePromise = null
        this.rejectPromise = null
      }
      this.$emit('verified', data)
    },
    refresh() {
      if (this.$refs.captcha) {
      	this.$refs.captcha.refresh()
      }
    }
  }
}
</script>

<style scoped>
/* ---------- 动画 ---------- */
.dialog-fade-enter-active,
.dialog-fade-leave-active {
  transition: opacity 0.3s ease;
}
.dialog-fade-enter,
.dialog-fade-leave-to {
  opacity: 0;
}

/* ---------- 遮罩层 ---------- */
.custom-dialog-wrapper {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.3);
  backdrop-filter: blur(4px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2000;
  padding: 16px;
}

/* ---------- 弹窗容器 ---------- */
.custom-dialog-container {
  background: #fff;
  border-radius: 24px;
  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);
  overflow: hidden;
  max-width: 90vw;
  max-height: 90vh;
  display: flex;
  flex-direction: column;
  transform: scale(1);
  animation: dialog-scale-in 0.2s ease;
}

@keyframes dialog-scale-in {
  0% { transform: scale(0.9); opacity: 0; }
  100% { transform: scale(1); opacity: 1; }
}

/* ---------- 弹窗头部 ---------- */
.dialog-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px 24px 8px 24px;
}
.dialog-title {
  font-size: 18px;
  font-weight: 600;
  color: #1a1a1a;
  letter-spacing: -0.3px;
}
.dialog-close {
  background: none;
  border: none;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: #666;
  transition: all 0.2s;
}
.dialog-close:hover {
  background: #f5f5f5;
  color: #333;
}

/* ---------- 弹窗内容 ---------- */
.dialog-body {
  padding: 8px 24px 16px 24px;
  display: flex;
  justify-content: center;
}

/* ---------- 底部提示 ---------- */
.dialog-footer {
  padding: 0 24px 20px 24px;
  text-align: center;
}
.footer-tip {
  font-size: 13px;
  color: #999;
  display: inline-block;
  position: relative;
}
.footer-tip::before,
.footer-tip::after {
  content: '';
  position: absolute;
  top: 50%;
  width: 20px;
  height: 1px;
  background: #e0e0e0;
}
.footer-tip::before {
  right: 100%;
  margin-right: 12px;
}
.footer-tip::after {
  left: 100%;
  margin-left: 12px;
}

/* ---------- 移动端适配 ---------- */
@media (max-width: 480px) {
  .dialog-header {
    padding: 16px 20px 4px 20px;
  }
  .dialog-body {
    padding: 4px 20px 12px 20px;
  }
  .dialog-footer {
    padding: 0 20px 16px 20px;
  }
}
</style>